import React, {useEffect, useRef, useState} from 'react'
import {useIntl} from 'react-intl'
import {PageTitle} from '../../../../_metronic/layout/core'
import {RecordsKeeperAIBreadCrumbs} from '../core/_constants'
import {DateTime} from 'luxon'
import {Dropdown} from 'react-bootstrap'
import TagManager from 'react-gtm-module'
import Skeleton from 'react-loading-skeleton'
// import ReactMarkdown from 'react-markdown'
import {toast} from 'react-toastify'
import {toAbsoluteUrl} from '../../../../_metronic/helpers'
import {useThemeMode} from '../../../../_metronic/partials'
import {GTMEvent} from '../../../hooks/gtmHelpers'
import {useDateFormat} from '../../../hooks/useDateFormat'
import {useTimeZone} from '../../../hooks/useTimeZone'
import ThreadTitle from '../../AI-banker/components/shortenString'
import SideAIChatMenu from '../../AI-banker/components/sideChatMenu'
import TypingAnimation from '../../AI-banker/components/typing-animation'
import {useAuth} from '../../auth'
import {errorMessage} from '../../profile/core/_constants'
import {DisplayImage} from '../../widgets/components/General/DisplayImage'
import {InfoCard2} from '../../widgets/components/UI/InfoCard2'
import Chaticon from '../../../../media/AI-banker/ic-chat.svg'
import Sendicon from '../../../../media/AI-banker/ic-send.svg'
import AIGenericImage from '../../../../media/AI-banker/ai-generic-image.png'
import ReactMarkdown from 'react-markdown'
import {useNavigate, useSearchParams} from 'react-router-dom'
import {getFileType, removeNullFields} from '../../../core/_util'
import {
  createActivityLog,
  getViewAndDownloadFile,
  rkCreateChatThread,
  rkDeleteChatThread,
  rkGetAllChatThreads,
  rkGetChatsFromThread,
  rkUpdateChatThreadTitle,
  sendSelectedEmailsApi,
} from '../core/_requests'
import folderIcon from '../../../../_metronic/assets/images/svg/data-room/blue-folder-icon.svg'
import deleteIcon from '../../../../media/stakeholders/ic-delete.svg'
import {ToolTipUI} from '../../widgets/components/UI/ToolTipUI'
import {getLocation} from '../../onboarding/core/_requests'
import ViewDocModal from '../../stakeholders/stakeholders-and-investors/components/individual/view-doc-modal'
import {DeleteClassificationModal} from '../components/RecordsClassifications/DeleteClassificationModal'

interface SendSelectedFiles {
  [key: string]: boolean // Define the type of sendSelectedFiles as an object with string keys and boolean values
}

const QueryAndPrompt = () => {
  const [searchParams, setSearchParams] = useSearchParams()
  const chatContainerRef = useRef<HTMLDivElement | null>(null)
  const textValue = searchParams.get('textInput') || ''
  const [selectedConversation, setSelectedConversation] = useState<string | null>(null)
  const [isBotTyping, setIsBotTyping] = useState<boolean>(false)
  const {currentUser, companyId, isShowHelpBanners, setShowBillingModal} = useAuth()
  const {formatMessage} = useIntl()
  const [chatThreads, setChatThreads] = useState<any[]>([])
  const [chatsFromThread, setChatsFromThread] = useState<any[]>([])
  const [userInput, setUserInput] = useState(textValue)
  const [isNewConversation, setIsNewConversation] = useState<boolean>(true)
  const [threadId, setThreadId] = useState<string | null>()
  const [promptText, setPromptText] = useState<string>()
  const [response, setResponse] = useState<any>()
  const [buttonIndex, setButtonIndex] = useState<number>(-1)
  const {getDateValue} = useDateFormat()
  const {getTimeZoneValue} = useTimeZone()
  const [isMessageSend, setIsMessageSend] = useState<boolean>(false)
  const [showKebabMenu, setShowKebabMenu] = useState(false)
  const [showThread, setShowThread] = useState<string>()
  const [newTitle, setNewTitle] = useState<string>('')
  const [editingThreadId, setEditingThreadId] = useState<string | null>(null)
  const [modalOpen, setModalOpen] = useState<boolean>(false)
  const [isDeleting, setIsDeleting] = useState<boolean>(false)
  const [isRenaming, setIsRenaming] = useState<boolean>(false)
  const dropdownRef = useRef<HTMLDivElement>(null)
  const [isloading, setLoading] = useState<boolean>(true)
  const [isTitleRenaming, setIsTitleRenaming] = useState<boolean>(false)
  const [editThreadId, setEditThreadId] = useState<string | null>(null)
  const [error, setError] = useState('')
  const [emailError, setEmailError] = useState('')
  const [isChatLoading, setIsChatLoading] = useState(false)
  const [isSideChatClick, setIsSideChatClick] = useState(false)
  const {mode} = useThemeMode()
  const [sendSelectedFiles, setSendSelectedFiles] = useState<SendSelectedFiles>({})
  const [selectedOptions, setSelectedOptions] = useState<any[]>([])
  const [isLoading, setIsLoading] = useState(false)
  const [isActive, setIsActive] = useState(false)
  const [viewableData, setViewableData] = useState<
    {downloadUrl: string; fileName: string; extension: string} | {}
  >({})
  const [fileName, setFileName] = useState('')
  const [emailList, setEmailList] = useState('')
  const [emailLoading, setEmailLoading] = useState(false)
  const [isSelectAll, setIsSelectAll] = useState(true)
  const navigate = useNavigate()
  let chatThreadId = searchParams.get('chatThreadId')
  const QueryPromptQuestions: Array<any> = [
    {
      id: 1,
      value: `Give me the latest annual report files from the 'Annual Reports' folder`,
    },
    {
      id: 2,
      value: `Retrieve all files from the 'Personal Documents' folder`,
    },
    {
      id: 3,
      value: `Extract all NDAs from the 'NDAs' folder`,
    },
  ]
  const getDeviceType = () => {
    const ua = navigator.userAgent

    if (
      /Mobile|iP(hone|od|ad)|Android|BlackBerry|IEMobile|Kindle|NetFront|Silk-Accelerated|(hpw|web)OS|Fennec|Minimo|Opera Mobi|Blazer|Dolfin|Dolphin|Skyfire|Zune/.test(
        ua
      )
    ) {
      return 'MOBILE'
    }
    return 'WEB'
  }

  const getOS = () => {
    const ua = navigator.userAgent
    if (/iPhone|iPad|iPod|Macintosh/.test(ua)) return 'APPLE'
    if (/Win/.test(ua)) return 'WINDOWS'
    if (/android/i.test(ua)) return 'ANDROID'
    return 'Unknown'
  }

  const createActivity = async (recordId: any) => {
    const os = getOS()
    const deviceTypeView = getDeviceType()
    const locationApiData = await getLocation()
    const city = locationApiData?.data.country_name
    const ipAddress = locationApiData?.data?.ip
    try {
      if (deviceTypeView && os && city && recordId && companyId) {
        const {
          data: {success, errors},
        } = await createActivityLog(
          companyId,
          recordId,
          os,
          deviceTypeView,
          city,
          ipAddress,
          'VIEWED'
        )
        if (!success) {
          errors.forEach((error: string) => {
            toast.error(formatMessage({id: error}))
          })
        }
      }
    } catch (err) {
      console.log(err)
    }
  }

  const handleInputChange = (e: any) => {
    const input = e.target.value

    // Check if input exceeds 2000 characters
    if (input.length > 2000) {
      setError('Message limit is 2000 characters')
    } else {
      setError('')
      setUserInput(input)
    }
  }
  // Fetch all chat threads
  const getAllThreads = async () => {
    if (chatsFromThread.length === 0) setLoading(true)
    try {
      const {
        data: {success, data},
      } = await rkGetAllChatThreads(companyId)
      if (success) {
        setChatThreads(data)
        if (data.length > 0) {
          setThreadId(chatThreadId ? chatThreadId : data[0].chatThreadId)
          handleSelectConversation(chatThreadId ? chatThreadId : data[0].chatThreadId)
        } else setIsMessageSend(false)
      }
    } catch (err) {
      console.error(err)
    } finally {
      if (textValue.length === 0) setLoading(false)
      setIsRenaming(false)
      setIsTitleRenaming(false)
      setEditingThreadId(null)
      setEditThreadId(null)
    }
  }

  useEffect(() => {
    if (!chatThreadId) {
      getAllThreads()
    }
  }, []) // eslint-disable-line react-hooks/exhaustive-deps
  useEffect(() => {
    if (chatThreadId) {
      getAllThreads()
    }
  }, [chatThreadId]) // eslint-disable-line react-hooks/exhaustive-deps
  // Fetch all chat threads
  const getAllChatsFromThread = async () => {
    setIsChatLoading(true)
    try {
      const {
        data: {success, data},
      } = await rkGetChatsFromThread(threadId, companyId)
      if (success) {
        setIsSelectAll(true)
        setSearchParams({chatThreadId: threadId!})
        setChatsFromThread(
          data
            .map((item: any) => {
              return {...item, isSelectAll: true}
            })
            .reverse()
        )
        setResponse('')
        setPromptText('')
        setIsSideChatClick(false)
        setIsNewConversation(false)
        setButtonIndex(-1)
        handleSelectConversation(data[0].chatThreadId)
      }
    } catch (err) {
      console.error(err)
    } finally {
      setIsChatLoading(false)
      setIsBotTyping(false)
    }
  }
  useEffect(() => {
    if (threadId) {
      getAllChatsFromThread()
    }
  }, [threadId]) // eslint-disable-line react-hooks/exhaustive-deps

  // Handle selecting a conversation
  const handleSelectConversation = (index: string) => {
    // if (index) {
    //   navigate(`/query-and-prompt?chatThreadId=${index}`);
    // }
    setSelectedConversation(index)
  }

  const groupThreadsByDate = (threads: any[]) => {
    const grouped: {[key: string]: any[]} = {}
    const now = DateTime.now()

    threads.forEach((thread) => {
      const threadDate = DateTime.fromISO(thread.lastMessageAt)

      // Calculate difference
      const diffInDays = Math.floor(now.diff(threadDate, 'days').days)

      // Determine the group key
      let groupKey = ''

      if (threadDate.hasSame(now, 'day')) {
        groupKey = 'Today'
      } else if (threadDate.hasSame(now.minus({days: 1}), 'day')) {
        groupKey = 'Yesterday'
      } else if (diffInDays <= 7) {
        groupKey = `${diffInDays} days ago`
      } else {
        // Handle dates older than 7 days
        const diffInMonths = Math.floor(now.diff(threadDate, 'months').months)
        if (diffInMonths < 12) {
          groupKey = `${diffInMonths} month${diffInMonths > 1 ? 's' : ''} ago`
        } else {
          const diffInYears = Math.floor(now.diff(threadDate, 'years').years)
          groupKey = `${diffInYears} year${diffInYears > 1 ? 's' : ''} ago`
        }
      }

      // Initialize group if not already
      if (!grouped[groupKey]) {
        grouped[groupKey] = []
      }

      // Add thread to the appropriate group
      grouped[groupKey].push(thread)
    })

    return grouped
  }

  const sortedDates = (groupedThreads: {[key: string]: any[]}) => {
    const dateOrder: {[key: string]: number} = {
      Today: 0,
      Yesterday: 1,
    }

    return Object.keys(groupedThreads).sort((a, b) => {
      const aOrder = dateOrder[a] !== undefined ? dateOrder[a] : Infinity
      const bOrder = dateOrder[b] !== undefined ? dateOrder[b] : Infinity

      // Sort "Today" and "Yesterday" first
      if (aOrder !== Infinity || bOrder !== Infinity) {
        return aOrder - bOrder
      }

      // Function to parse date key
      const parseDateKey = (key: string): DateTime => {
        const dateParts = key.split(' ')

        if (dateParts.length === 3) {
          // e.g., "4 days ago"
          const daysAgo = parseInt(dateParts[0], 10)
          return DateTime.now().minus({days: daysAgo})
        } else if (dateParts.length === 4) {
          // e.g., "2 months ago" or "1 year ago"
          const value = parseInt(dateParts[0], 10)
          const unit = dateParts[1]
          if (unit === 'month' || unit === 'months') {
            return DateTime.now().minus({months: value})
          } else if (unit === 'year' || unit === 'years') {
            return DateTime.now().minus({years: value})
          }
        }
        // Handle unexpected cases by assuming the format is incorrect
        return DateTime.now() // Default to now
      }

      const aDate = parseDateKey(a)
      const bDate = parseDateKey(b)

      return bDate.toMillis() - aDate.toMillis()
    })
  }

  const groupedThreads = groupThreadsByDate(chatThreads)
  const sortedThreadDates = sortedDates(groupedThreads)

  function formatResponseForMarkdown(response: any) {
    return response
      ? response
          .replace(/([0-9]+)\.\s*/g, '\n\n$1. ')
          .replace(/(\*\*.*?\*\*):\s*/g, '$1:\n\n')
          .replace(/(\n{2,})/g, '\n\n')
          .trim()
      : null
  }

  useEffect(() => {
    if (textValue.length > 0) {
      chatSend()
    }
  }, [textValue]) // eslint-disable-line react-hooks/exhaustive-deps

  const chatSend = async () => {
    setIsMessageSend(true)
    setPromptText(userInput)
    setIsBotTyping(true)
    if (textValue.length) setLoading(true)
    try {
      if (companyId) {
        let payload: any
        if (isNewConversation) {
          payload = {
            prompt: userInput,
          }
        } else {
          payload = {
            prompt: userInput,
            chatThreadId: threadId,
          }
        }
        setUserInput('')
        const {
          data: {data, success, errors},
        }: any = await rkCreateChatThread(payload, companyId)
        if (success) {
          // setResponse(data)
          setThreadId(data.chatThreadId)
          await getAllThreads()
          setSearchParams({chatThreadId: data.chatThreadId})
          await getAllChatsFromThread()
          TagManager.dataLayer({
            dataLayer: {
              event: GTMEvent.AddChatThreadSuccessful,
              action: 'normal',
              metadata: removeNullFields({
                company_id: companyId,
                chat_thread_id: data?.chatThreadId,
                user_id: currentUser?.userId,
                first_name: currentUser?.firstName,
                last_name: currentUser?.lastName,
                email: currentUser?.email,
              }),
            },
          })
        } else {
          setPromptText('')
          errors.forEach((error: string) => {
            if (
              error === errorMessage.UPGRADE_BILLING_PLAN_LIMIT_EXCEEDED ||
              error === errorMessage.UPGRADE_BILLING_PLAN_FEATURE
            ) {
              setShowBillingModal(true)
              toast.error(formatMessage({id: error}), {autoClose: false})
            } else {
              toast.error(formatMessage({id: error}))
            }
          })
          TagManager.dataLayer({
            dataLayer: {
              event: GTMEvent.AddChatThreadFailed,
              action: 'normal',
              metadata: removeNullFields({
                company_id: companyId,
                user_id: currentUser?.userId,
                first_name: currentUser?.firstName,
                last_name: currentUser?.lastName,
                email: currentUser?.email,
                error: errors[0],
              }),
            },
          })
        }
      }
    } catch (err) {
      console.log(err)
    } finally {
      setIsBotTyping(false)
      setLoading(false)
      setIsRenaming(false)
      setIsTitleRenaming(false)
      setEditingThreadId(null)
      setEditThreadId(null)
    }
  }

  const handleKeyDown = (e: any) => {
    if (e.key === 'Enter') {
      handleUpdateTitle()
    }
  }

  const handleUpdateTitle = async () => {
    setIsRenaming(true)
    try {
      if (companyId) {
        let payload: any = {
          title: newTitle.trim(),
        }
        const {
          data: {success, errors},
        }: any = await rkUpdateChatThreadTitle(editingThreadId, payload, companyId)
        if (success) {
          getAllThreads()
          TagManager.dataLayer({
            dataLayer: {
              event: GTMEvent.UpdateChatThreadTitleSuccessful,
              action: 'normal',
              metadata: removeNullFields({
                company_id: companyId,
                thread_id: editingThreadId,
                title: payload?.title,
                user_id: currentUser?.userId,
                first_name: currentUser?.firstName,
                last_name: currentUser?.lastName,
                email: currentUser?.email,
              }),
            },
          })
        } else {
          errors.forEach((error: string) => {
            toast.error(formatMessage({id: error}))
          })
          TagManager.dataLayer({
            dataLayer: {
              event: GTMEvent.UpdateChatThreadTitleFailed,
              action: 'normal',
              metadata: removeNullFields({
                company_id: companyId,
                thread_id: editingThreadId,
                title: payload?.title,
                user_id: currentUser?.userId,
                first_name: currentUser?.firstName,
                last_name: currentUser?.lastName,
                email: currentUser?.email,
                error: errors[0],
              }),
            },
          })
        }
      }
    } catch (err) {
      console.log(err)
    } finally {
    }
  }

  const deleteChat = async () => {
    setIsDeleting(true)
    try {
      if (companyId) {
        const {
          data: {success, errors},
        }: any = await rkDeleteChatThread(showThread, companyId)
        if (success) {
          getAllThreads()
          setModalOpen(false)
          toast.success('Chat Delete Successfully')
          TagManager.dataLayer({
            dataLayer: {
              event: GTMEvent.DeleteChatThreadSuccessful,
              action: 'normal',
              metadata: removeNullFields({
                company_id: companyId,
                thread_id: showThread,
                user_id: currentUser?.userId,
                first_name: currentUser?.firstName,
                last_name: currentUser?.lastName,
                email: currentUser?.email,
              }),
            },
          })
        } else {
          errors.forEach((error: string) => {
            toast.error(formatMessage({id: error}))
          })
          TagManager.dataLayer({
            dataLayer: {
              event: GTMEvent.DeleteChatThreadFailed,
              action: 'normal',
              metadata: removeNullFields({
                company_id: companyId,
                thread_id: showThread,
                user_id: currentUser?.userId,
                first_name: currentUser?.firstName,
                last_name: currentUser?.lastName,
                email: currentUser?.email,
                error: errors[0],
              }),
            },
          })
        }
      }
    } catch (err) {
      console.log(err)
    } finally {
      setIsDeleting(false)
    }
  }
  const handleClickOutside = (event: MouseEvent) => {
    if (dropdownRef.current && !dropdownRef.current.contains(event.target as Node)) {
      setShowKebabMenu(false)
      setEditingThreadId(null)
    }
  }

  useEffect(() => {
    document.addEventListener('mousedown', handleClickOutside)
    return () => {
      document.removeEventListener('mousedown', handleClickOutside)
    }
  }, [])

  const handleCheckboxChange = async (checked: boolean, option: string, chatId: any) => {
    let updatedOptions: any[] = []

    // Use useEffect to update selectedOptions after currentChatId updates

    if (!checked) {
      updatedOptions = selectedOptions.filter((item) => item !== option)
    } else {
      updatedOptions = [...selectedOptions, option]
    }

    setSelectedOptions((prev: any) => {
      const selectedFiles = chatsFromThread
        .filter((item: any) => item.chatId === chatId)
        .flatMap((item: any) => item.response.referred_docs)
        .filter(
          (doc: any) =>
            doc.fileInfo &&
            doc.fileInfo.fileVersionId &&
            updatedOptions.includes(doc.fileInfo.fileVersionId)
        ) // Match existing selections
        .map((doc: any) => doc.fileInfo.fileVersionId) // Extract fileVersionId
      return selectedFiles // Update state with selected file IDs
    })

    // Update chat state
    setChatsFromThread((prevChats: any[]) =>
      prevChats.map((chat) =>
        chat.chatId === chatId
          ? {
              ...chat,
              isSelectAll:
                updatedOptions.length ===
                chat.response.referred_docs.filter((chat: any) => chat.fileInfo).length
                  ? false
                  : true,
            }
          : {...chat, isSelectAll: true}
      )
    )
    setSendSelectedFiles((prev: any) => {
      if (
        (Object.keys(prev).length && !Object.keys(prev).includes(chatId)) ||
        selectedOptions.length === 0
      ) {
        return []
      } else return prev
    })

    setIsSelectAll(false)
  }

  const handleRemoveFileToSend = (option: string) => {
    setSelectedOptions(selectedOptions.filter((item) => item !== option))
  }

  const handleViewFile = async (fileVersionId: string, recordId: string) => {
    if (!companyId) return
    setIsActive(true)
    setIsLoading(true)
    try {
      const {
        data: {data, success},
      } = await getViewAndDownloadFile(fileVersionId, companyId)
      if (success) {
        setViewableData(data)
        createActivity(recordId)
      }
    } catch (error) {
      toast.error('Failed to download document')
    } finally {
      setIsLoading(false)
    }
  }

  const handleSendEmail = async (e: any) => {
    if (!companyId) return

    e.preventDefault()
    if (emailList.length === 0) {
      setEmailError('Email List is required')
      return
    }

    const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/

    // Use split to create an array of emails and find the first invalid email
    const invalidEmail = emailList.split(',').find((email) => !emailRegex.test(email.trim()))

    if (invalidEmail) {
      setEmailError(`Invalid email found: ${invalidEmail}`)
      return
    }

    setEmailError('')

    setEmailLoading(true)

    try {
      const {
        data: {success},
      } = await sendSelectedEmailsApi(emailList, selectedOptions, companyId!)
      if (success) {
        toast.success('Email sent successfully')
      } else {
        toast.error('Email sending failed,Please try again')
      }
    } catch (error) {
      toast.error('Failed to send email')
    } finally {
      setEmailLoading(false)
      setEmailList('')
      setSelectedOptions([])
      setChatsFromThread((prevChats: any[]) =>
        prevChats.map((chat) => {
          return {...chat, isSelectAll: true}
        })
      )
    }
  }
  useEffect(() => {
    if (chatContainerRef.current && isSelectAll) {
      chatContainerRef.current.scrollTop = chatContainerRef.current.scrollHeight
    }
  }, [chatsFromThread, userInput, isSelectAll])
  console.log(chatsFromThread, 'chatsFromThread', sendSelectedFiles)

  return (
    <div>
      <PageTitle
        breadcrumbs={RecordsKeeperAIBreadCrumbs}
        description={formatMessage({id: 'Query & Prompt'})}
      >
        {formatMessage({id: 'RecordsKeeper AI'})}
      </PageTitle>
      <div className='d-block gap-4 mb-4 d-md-flex px-6'>
        {/* mobile Menu chat threads */}
        <SideAIChatMenu
          setIsNewConversation={setIsNewConversation}
          setChatsFromThread={setChatsFromThread}
          setThreadId={setThreadId}
          setIsMessageSend={setIsMessageSend}
          chatThreads={chatThreads}
          getAllThreads={getAllThreads}
          setEditThreadId={setEditThreadId}
          editThreadId={editThreadId}
          isTitleRenaming={isTitleRenaming}
          setIsTitleRenaming={setIsTitleRenaming}
        />

        <div className='col-3 d-none d-md-block w-25'>
          <div className='d-flex bg-white rounded-2 p-4 flex-column h-100'>
            <div
              className='flex-grow-1 d-flex flex-column'
              style={{height: 'calc(100vh - 250px)', overflow: 'hidden'}}
            >
              <button
                className={
                  `btn px-2 py-3 w-100 mb-4 ` +
                  (mode === 'dark'
                    ? `btn-outline-primary btn-no-hover-dark`
                    : `btn-outline-primary btn-hover-primary bg-new-conv-btn btn-no-hover`)
                }
                onClick={() => {
                  setIsNewConversation(true)
                  setChatsFromThread([])
                  handleSelectConversation('')
                  setSearchParams({})
                  setThreadId(null)
                  setIsMessageSend(false)
                }}
              >
                <div className='d-flex align-items-center justify-content-center'>
                  <img
                    src={toAbsoluteUrl('/media/icons/RecordsKeeperAI/ic-ai.svg')}
                    alt='AI Icon'
                    className='me-2'
                  />
                  <span className='font-size-13 ms-2'>
                    {formatMessage({id: 'New Query & Prompt'})}
                  </span>
                </div>
              </button>
              <div
                className='d-flex flex-column h-100'
                style={{overflowY: 'scroll', overflowX: 'hidden'}}
              >
                {isShowHelpBanners && (
                  <InfoCard2
                    title={formatMessage({
                      id: 'Using RecordsKeeper AI Chat Prompts & Queries to Retrieve Documents',
                    })}
                    className='mb-0'
                    desc={formatMessage({
                      id: 'This page allows you to interact with RecordsKeeper AI to quickly find and retrieve your files. Simply type a query or choose from sample questions to get started. Use the "New Query & Prompt" button to initiate a new search and get the information you need instantly.',
                    })}
                    slug='https://help.recordskeeper.ai/en/articles/10373092-how-to-retrieve-documents-using-prompt-query-feature'
                  />
                )}

                <div className='d-flex flex-column h-100'>
                  {isloading ? (
                    <>
                      <div className='d-flex flex-column gap-2'>
                        <Skeleton
                          height={40}
                          count={8}
                          className='mb-2'
                          baseColor='var(--kt-skeleton-bg-color)'
                          highlightColor='var(--kt-skeleton-highlight-bg-color)'
                        />
                      </div>
                    </>
                  ) : (
                    <>
                      {sortedThreadDates.length === 0 ? (
                        <div
                          className='w-100 h-100 bg-white d-flex align-items-center justify-content-center rounded-2 py-8'
                          style={{padding: '100px 0'}}
                        >
                          <div className='text-center d-flex flex-column'>
                            <div>
                              <img
                                src={toAbsoluteUrl('/media/icons/investor-updates/no-chat.svg')}
                                alt='no-data-img'
                                height={125}
                                width={125}
                              />
                            </div>
                            <div className='w-100'>
                              <h1 className='fs-5'>
                                {formatMessage({id: 'No Chat Threads To Show'})}
                              </h1>

                              <p className='w-100 fs-8 mb-0 px-4'>
                                {formatMessage({
                                  id: `Looks like there are no active chats at the moment. Start a new conversation`,
                                })}
                              </p>
                            </div>
                          </div>
                        </div>
                      ) : (
                        sortedThreadDates.map((date: any) => (
                          <div key={date}>
                            <div className='font-size-13 text-dark mt-4 mb-2'>{date}</div>
                            {groupedThreads[date].map((thread: any, index: any) => (
                              <div key={thread.chatThreadId} className={`position-relative`}>
                                <div
                                  onClick={() => {
                                    setIsSideChatClick(true)
                                    handleSelectConversation(thread.chatThreadId)
                                    setThreadId(thread.chatThreadId)
                                    setIsNewConversation(false)
                                  }}
                                  className={`d-flex align-items-center p-2 gap-2 cursor-pointer justify-content-between w-100 ${
                                    selectedConversation?.trim() === thread.chatThreadId
                                      ? mode === 'dark'
                                        ? `selected-class-dark`
                                        : `selected-class`
                                      : ''
                                  }`}
                                  onDoubleClick={() => {
                                    setEditingThreadId(thread.chatThreadId)
                                    setNewTitle(thread.title)
                                  }}
                                >
                                  <div
                                    className={`d-flex gap-2 align-items-center justify-content-between w-100 ${
                                      selectedConversation?.trim() === thread.chatThreadId
                                        ? mode === 'dark'
                                          ? `selected-class-dark`
                                          : `selected-class`
                                        : ''
                                    }`}
                                  >
                                    <div
                                      className='d-flex align-items-center gap-2'
                                      style={{maxWidth: '80%'}}
                                    >
                                      <img src={Chaticon} alt='Chat icon' />
                                      {editingThreadId === thread.chatThreadId ? (
                                        isRenaming ? (
                                          formatMessage({id: 'Renaming...'})
                                        ) : (
                                          <div ref={dropdownRef}>
                                            <input
                                              type='text'
                                              className='form-control'
                                              value={newTitle}
                                              onChange={(e) => setNewTitle(e.target.value)}
                                              onKeyDown={(e) => handleKeyDown(e)}
                                              // onBlur={() => setEditingThreadId(null)}
                                              autoFocus
                                            />
                                          </div>
                                        )
                                      ) : (
                                        <ThreadTitle title={thread.title} />
                                      )}
                                    </div>
                                    <div>
                                      <Dropdown.Toggle
                                        className={
                                          `bi bi-three-dots-vertical p-1 bg-white ` +
                                          (mode === 'dark'
                                            ? `text-white bg-dark btn-active-dark`
                                            : `text-dark btn-active`)
                                        }
                                        style={{width: '32px', height: '32px'}}
                                        onClick={(e) => {
                                          e.stopPropagation()
                                          setShowKebabMenu((prev) => !prev)
                                          setShowThread(thread.chatThreadId)
                                        }}
                                      ></Dropdown.Toggle>
                                    </div>
                                    {showKebabMenu && thread.chatThreadId === showThread && (
                                      <div
                                        ref={dropdownRef}
                                        className='card w-100px h-auto shadow rounded kebab-menu-dropdown-adjust cursor-pointer ms-auto'
                                      >
                                        <div
                                          className={
                                            'border-bottom border-gray-300 border-bottom-2 px-4 py-3 ' +
                                            (mode === 'dark'
                                              ? `dropdown-items-color-dark`
                                              : `dropdown-items-color`)
                                          }
                                        >
                                          <div
                                            className='m-0'
                                            onClick={() => {
                                              setEditingThreadId(thread.chatThreadId)
                                              setNewTitle(thread.title)
                                              setShowKebabMenu(!showKebabMenu)
                                            }}
                                          >
                                            {formatMessage({id: 'Rename'})}
                                          </div>
                                        </div>
                                        <div
                                          className={
                                            'px-4 py-3 ' +
                                            (mode === 'dark'
                                              ? `dropdown-items-color-dark`
                                              : `dropdown-items-color`)
                                          }
                                        >
                                          <div
                                            className='m-0 text-danger'
                                            onClick={() => {
                                              setModalOpen(true)
                                            }}
                                          >
                                            {formatMessage({id: 'Delete'})}
                                          </div>
                                        </div>
                                      </div>
                                    )}
                                  </div>
                                </div>
                              </div>
                            ))}
                          </div>
                        ))
                      )}
                    </>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className='col-9 w-100 w-md-75'>
          <div className='d-flex bg-white rounded-2 p-4 flex-column'>
            {isChatLoading && isSideChatClick ? (
              <div
                className='flex-grow-1 d-flex flex-column justify-content-end'
                style={{height: 'calc(100vh - 250px)', overflow: 'hidden'}}
              >
                {Array.from({length: 3}).map((_, index) => (
                  <>
                    <div className='d-flex gap-2 w-100 mt-4'>
                      <Skeleton
                        width={24}
                        height={24}
                        baseColor='var(--kt-skeleton-bg-color)'
                        highlightColor='var(--kt-skeleton-highlight-bg-color)'
                        className='rounded-circle'
                      />
                      <Skeleton
                        containerClassName='w-100'
                        width={'50%'}
                        height={80}
                        baseColor='var(--kt-skeleton-bg-color)'
                        highlightColor='var(--kt-skeleton-highlight-bg-color)'
                      />
                    </div>
                    <div className='d-flex gap-2 w-100 justify-content-end mt-4'>
                      <Skeleton
                        containerClassName='w-100 d-flex justify-content-end'
                        width={'50%'}
                        height={80}
                        baseColor='var(--kt-skeleton-bg-color)'
                        highlightColor='var(--kt-skeleton-highlight-bg-color)'
                      />
                      <Skeleton
                        width={24}
                        height={24}
                        baseColor='var(--kt-skeleton-bg-color)'
                        highlightColor='var(--kt-skeleton-highlight-bg-color)'
                        className='rounded-circle'
                      />
                    </div>{' '}
                  </>
                ))}
              </div>
            ) : (
              <div
                className='flex-grow-1 d-flex flex-column justify-content-end'
                style={{height: 'calc(100vh - 250px)', overflow: 'hidden'}}
              >
                {/* Prompt message */}
                <div
                  className={`d-flex flex-column justify-content-center align-items-center h-80 ${
                    chatsFromThread.length === 0 ? 'd-block' : 'd-none'
                  }`}
                  style={{marginBlock: 'auto'}}
                >
                  {!isMessageSend && (
                    <>
                      <h5 className='text-center mb-4'>
                        {formatMessage({id: 'Sample questions you can ask me'})}
                      </h5>
                      <div className='d-flex flex-column align-items-center w-100 w-md-50'>
                        {QueryPromptQuestions.map((question) => (
                          <button
                            key={question.id}
                            className={
                              `btn btn-lg mb-3 w-100 fw-normal font-size-13 ` +
                              (mode === 'dark' ? `btn-prompt-primary-dark` : `btn-prompt-primary`)
                            }
                            onClick={() => {
                              setUserInput(question.value)
                              setButtonIndex(question.id)
                              // if (question.value === "Give me the latest annual report files from the 'Annual Reports' folder") {
                              //     handleCustomResponse() // Trigger custom logic
                              // }
                            }}
                            disabled={buttonIndex === question.id}
                          >
                            {question.value}
                          </button>
                        ))}
                      </div>
                    </>
                  )}
                </div>
                {/* Chat List */}
                <div
                  className='d-flex flex-column gap-2'
                  ref={chatContainerRef}
                  style={{maxHeight: 'calc(100vh - 250px)', overflowY: 'auto'}}
                >
                  {chatsFromThread.map((chat, index) => (
                    <div key={index}>
                      <div className='d-flex gap-2 mb-4 user-parent'>
                        {isloading ? (
                          <Skeleton
                            height={24}
                            width={24}
                            className='my-2'
                            baseColor='var(--kt-skeleton-bg-color)'
                            highlightColor='var(--kt-skeleton-highlight-bg-color)'
                          />
                        ) : (
                          <>
                            <DisplayImage
                              imgName={currentUser?.profileImg}
                              alt='User'
                              height='24px'
                              width='24px'
                              fit='contain'
                              className='rounded-circle'
                            />
                          </>
                        )}

                        {isloading ? (
                          <Skeleton
                            height={80}
                            count={1}
                            className='my-2'
                            baseColor='var(--kt-skeleton-bg-color)'
                            highlightColor='var(--kt-skeleton-highlight-bg-color)'
                          />
                        ) : (
                          <>
                            <div
                              className={
                                'message mb-0 d-flex flex-column p-4 rounded-2 ' +
                                (mode === 'dark' ? `user-message-dark` : `user-message`)
                              }
                            >
                              <p className='m-0'>{chat.prompt}</p>
                              <p className='font-size-10 text-muted m-0 dateStyle'>
                                {chat.timestamp
                                  ? getDateValue(chat.timestamp?.toString())
                                    ? getDateValue(chat.timestamp?.toString())
                                    : DateTime.fromISO(chat.timestamp?.toString()).toLocaleString(
                                        DateTime.DATE_MED
                                      )
                                  : '-'}{' '}
                                {chat.timestamp && getTimeZoneValue(chat.timestamp?.toString())}
                              </p>
                            </div>
                          </>
                        )}
                      </div>
                      <div className='d-flex gap-2'>
                        {chat.response.textual_response && (
                          <img
                            src={toAbsoluteUrl('/media/icons/sidebar/v2/ic-ai-banker-active.svg')}
                            alt='Ai'
                            height='24px'
                            width='24px'
                          />
                        )}

                        {isloading ? (
                          <Skeleton
                            height={80}
                            count={1}
                            className='my-2'
                            baseColor='var(--kt-skeleton-bg-color)'
                            highlightColor='var(--kt-skeleton-highlight-bg-color)'
                          />
                        ) : (
                          <>
                            {chat.response.textual_response && (
                              <div
                                className={
                                  'message mb-0 d-flex flex-column p-4 rounded-2 w-90 ' +
                                  (mode === 'dark' ? `bot-message-dark` : `bot-message`)
                                }
                              >
                                {chat.response.referred_docs.filter((docs: any) => docs.fileInfo)
                                  .length > 0 ? (
                                  <div
                                    className={
                                      'message mb-0 d-flex flex-column  pb-2 rounded-2 w-100' +
                                      (mode === 'dark' ? `bot-message-dark` : `bot-message`)
                                    }
                                  >
                                    <p className='m-0'>
                                      <div>
                                        {chat.response.textual_response ? (
                                          <ReactMarkdown>
                                            {formatResponseForMarkdown(
                                              chat.response.textual_response
                                            )}
                                          </ReactMarkdown>
                                        ) : (
                                          <></>
                                        )}
                                        <div>
                                          <p className='mb-2'>
                                            Found{' '}
                                            {
                                              chat.response.referred_docs.filter(
                                                (docs: any) => docs.fileInfo
                                              ).length
                                            }{' '}
                                            Files'
                                          </p>
                                          <div className='bg-white rounded p-2'>
                                            <div>
                                              {chat.response.referred_docs.map((record: any) => (
                                                <>
                                                  {record.fileInfo && (
                                                    <div
                                                      key={record.fileInfo.id}
                                                      className='d-flex align-items-center justify-content-between my-2 pb-2 border-bottom gap-2'
                                                    >
                                                      <div className='d-flex align-items-center gap-2'>
                                                        <div className='form-check'>
                                                          <input
                                                            className='form-check-input'
                                                            type='checkbox'
                                                            checked={selectedOptions.includes(
                                                              record.fileInfo.fileVersionId
                                                            )}
                                                            onChange={async (e) => {
                                                              await handleCheckboxChange(
                                                                e.target.checked,
                                                                record.fileInfo.fileVersionId,
                                                                chat.chatId
                                                              )
                                                            }}
                                                            id='flexCheckDefault'
                                                          />
                                                        </div>
                                                        <img
                                                          src={getFileType(
                                                            record.fileInfo.fileVersionName
                                                          )}
                                                          alt={record.fileInfo.fileVersionName}
                                                          height={32}
                                                          width={32}
                                                        />
                                                        <div className='d-flex flex-column'>
                                                          <p className='font-size-13 m-0'>
                                                            {record.fileInfo.name}
                                                          </p>
                                                          <p className='font-size-10 m-0 text-muted'>
                                                            <span>
                                                              <img
                                                                src={folderIcon}
                                                                alt='folder icon'
                                                                height={16}
                                                                width={16}
                                                                className='me-2'
                                                              />
                                                            </span>
                                                            {record.fileInfo.folderPath}
                                                          </p>
                                                        </div>
                                                      </div>
                                                      <div className='d-flex gap-2 align-items-center'>
                                                        <div
                                                          className='p-2 cursor-pointer bg-light rounded-2 d-flex justify-content-center  align-items-center'
                                                          role='button'
                                                          onClick={() => {
                                                            setFileName(record.fileInfo.name)
                                                            handleViewFile(
                                                              record.fileInfo.fileVersionId,
                                                              record.fileInfo.id
                                                            )
                                                          }}
                                                        >
                                                          <img
                                                            src={toAbsoluteUrl(
                                                              '/media/icons/RecordsKeeperAI/ic-view.svg'
                                                            )}
                                                            alt='view'
                                                            width={11}
                                                            height={11}
                                                          />
                                                        </div>
                                                        <div
                                                          className='p-2 cursor-pointer bg-light rounded-2 d-flex justify-content-center  align-items-center'
                                                          role='button'
                                                          onClick={() => {
                                                            const fileUrl =
                                                              record.fileInfo.folderPath.split('/')
                                                            const encodedPath = fileUrl
                                                              .map(encodeURIComponent)
                                                              .join('/')
                                                            navigate(
                                                              `/rk/records-and-files/${encodedPath}`
                                                            )
                                                          }}
                                                        >
                                                          <i className='fa-solid fa-arrow-up-right-from-square ms-1 cursor-pointer'></i>
                                                        </div>
                                                      </div>
                                                    </div>
                                                  )}
                                                </>
                                              ))}
                                            </div>
                                            <div className='d-flex justify-content-between px-1 mt-4'>
                                              {chat.isSelectAll ? (
                                                <p
                                                  className='text-primary'
                                                  role='button'
                                                  onClick={() => {
                                                    setSelectedOptions(
                                                      chat.response.referred_docs
                                                        .filter((record: any) => record.fileInfo) // Ensure fileInfo and fileVersionId exist
                                                        .map(
                                                          (record: any) =>
                                                            record.fileInfo.fileVersionId
                                                        )
                                                    )
                                                    chat.isSelectAll = false
                                                  }}
                                                >
                                                  {formatMessage({id: 'Select All'})}
                                                </p>
                                              ) : (
                                                <p
                                                  className='text-primary'
                                                  role='button'
                                                  onClick={() => {
                                                    setSelectedOptions([])
                                                    chat.isSelectAll = true
                                                    setSendSelectedFiles({})
                                                  }}
                                                >
                                                  {formatMessage({id: 'Deselect All'})}
                                                </p>
                                              )}
                                              <p
                                                className='text-primary'
                                                role='button'
                                                onClick={() => {
                                                  setSendSelectedFiles((prev: any) => {
                                                    console.log(
                                                      Object.keys(prev),
                                                      Object.keys(prev).includes(chat.chatId),
                                                      'ppp'
                                                    )
                                                    if (
                                                      Object.keys(prev).length &&
                                                      !Object.keys(prev).includes(chat.chatId)
                                                    ) {
                                                      setSelectedOptions([])
                                                      setChatsFromThread((prevChats: any[]) =>
                                                        prevChats.map((chat) => {
                                                          return {...chat, isSelectAll: true}
                                                        })
                                                      )
                                                    }
                                                    return {
                                                      [chat.chatId]: true, // Set the current chat to true
                                                    }
                                                  })
                                                }}
                                              >
                                                <i className='fa-regular fa-envelope text-primary me-1'></i>
                                                {formatMessage({id: 'Send Selected Files'})}
                                              </p>
                                            </div>
                                          </div>
                                          {sendSelectedFiles[chat.chatId] &&
                                            selectedOptions.length > 0 && (
                                              <>
                                                <div className='my-4 position-relative'>
                                                  <label htmlFor='emailList' className='form-label'>
                                                    {formatMessage({
                                                      id: 'Enter Email ids to send files (separated by comma)',
                                                    })}
                                                    <ToolTipUI
                                                      tooltipText={formatMessage({
                                                        id: 'Enter recipient email addresses separated by commas to securely share selected files through RecordsKeeper.AI.',
                                                      })}
                                                    />
                                                  </label>

                                                  <input
                                                    type='text'
                                                    className='form-control pe-12'
                                                    id='emailList'
                                                    value={emailList}
                                                    onChange={(e) => setEmailList(e.target.value)}
                                                    placeholder='Enter Email Address'
                                                    disabled={
                                                      sendSelectedFiles[chat.chatId] && emailLoading
                                                    }
                                                    onKeyDown={(e) => handleSendEmail}
                                                  />
                                                  {emailLoading ? (
                                                    <div
                                                      className='indicator-label font-size-13 p-0 position-absolute'
                                                      style={{right: '14px', top: '35px'}}
                                                    >
                                                      <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
                                                    </div>
                                                  ) : (
                                                    <button
                                                      type='button'
                                                      className='position-absolute btn btn-transparent p-0 py-1'
                                                      style={{right: '14px', top: '35px'}}
                                                      disabled={
                                                        sendSelectedFiles[chat.chatId] &&
                                                        emailLoading
                                                      }
                                                      onClick={handleSendEmail}
                                                    >
                                                      <img src={Sendicon} alt='Send Message' />
                                                    </button>
                                                  )}

                                                  {emailError && (
                                                    <div className='text-danger font-size-12 mt-1'>
                                                      {emailError}
                                                    </div>
                                                  )}
                                                </div>
                                                <div className='mt-6'>
                                                  <p className='mb-2'>
                                                    {formatMessage({
                                                      id: 'Files to be sent to above email ids are:',
                                                    })}
                                                  </p>
                                                  {chat.response.referred_docs
                                                    .filter((record: any) => record.fileInfo)
                                                    .map((record: any) => (
                                                      <>
                                                        {selectedOptions.includes(
                                                          record.fileInfo.fileVersionId
                                                        ) && (
                                                          <div
                                                            key={record.id}
                                                            className='d-flex align-items-center justify-content-between my-2'
                                                          >
                                                            <div className='d-flex align-items-center gap-2'>
                                                              <img
                                                                src={getFileType(
                                                                  record.fileInfo.fileVersionName
                                                                )}
                                                                alt={
                                                                  record.fileInfo.fileVersionName
                                                                }
                                                                height={20}
                                                                width={20}
                                                              />
                                                              <div className='d-flex flex-column'>
                                                                <p className='font-size-13 m-0'>
                                                                  {record.fileInfo.name}
                                                                </p>
                                                              </div>
                                                            </div>
                                                            <div className='d-flex gap-2'>
                                                              <div
                                                                className='p-3 cursor-pointer d-flex justify-content-center align-items-top height-36'
                                                                role='button'
                                                                onClick={() => {
                                                                  handleRemoveFileToSend(
                                                                    record.fileInfo.fileVersionId
                                                                  )
                                                                  chat.isSelectAll = true
                                                                }}
                                                              >
                                                                <img
                                                                  src={deleteIcon}
                                                                  alt='delete'
                                                                  width={20}
                                                                  height={20}
                                                                />
                                                              </div>
                                                            </div>
                                                          </div>
                                                        )}
                                                      </>
                                                    ))}
                                                </div>
                                              </>
                                            )}
                                        </div>
                                      </div>
                                    </p>
                                  </div>
                                ) : (
                                  <p className='m-0'>
                                    {chat.response.textual_response ? (
                                      <ReactMarkdown>
                                        {formatResponseForMarkdown(chat.response.textual_response)}
                                      </ReactMarkdown>
                                    ) : (
                                      <></>
                                    )}
                                  </p>
                                )}
                                <p className='font-size-10 text-muted m-0 dateStyle'>
                                  {chat.timestamp
                                    ? getDateValue(chat.timestamp?.toString())
                                      ? getDateValue(chat.timestamp?.toString())
                                      : DateTime.fromISO(chat.timestamp?.toString()).toLocaleString(
                                          DateTime.DATE_MED
                                        )
                                    : '-'}{' '}
                                  {chat.timestamp && getTimeZoneValue(chat.timestamp?.toString())}
                                </p>
                              </div>
                            )}
                          </>
                        )}
                      </div>
                    </div>
                  ))}
                  {promptText && (
                    <div className='d-flex gap-2 mb-4 user-parent'>
                      <DisplayImage
                        imgName={''}
                        alt='User'
                        height='24px'
                        width='24px'
                        fit='contain'
                        className='rounded-circle'
                      />
                      <div
                        className={
                          'message mb-0 d-flex flex-column p-2 rounded-2 ' +
                          (mode === 'dark' ? `user-message-dark` : `user-message`)
                        }
                      >
                        <p className='m-0'>{promptText}</p>
                        <p className='font-size-10 text-muted m-0 dateStyle min-w-150px'>{'-'}</p>
                      </div>
                    </div>
                  )}

                  {/* Bot typing indicator */}
                  {isBotTyping ? (
                    <div className='d-flex align-items-center gap-2'>
                      <img
                        src={toAbsoluteUrl('/media/icons/sidebar/v2/ic-ai-banker-active.svg')}
                        alt='Ai'
                        height='24px'
                        width='24px'
                      />
                      <TypingAnimation />
                    </div>
                  ) : response ? (
                    <div className='d-flex gap-2'>
                      <DisplayImage
                        imgName={AIGenericImage}
                        alt='AI'
                        height='24px'
                        width='24px'
                        fit='contain'
                        className='rounded-circle'
                      />
                      <div
                        className={
                          'message mb-0 d-flex flex-column p-2 rounded-2 ' +
                          (mode === 'dark' ? `bot-message-dark` : `bot-message`)
                        }
                      >
                        <p className='m-0'>{response?.response.textual_response}</p>
                        <p className='font-size-10 text-muted m-0 dateStyle'>{'-'}</p>
                      </div>
                    </div>
                  ) : (
                    ''
                  )}
                </div>
              </div>
            )}

            {/* Message Input */}
            <div className='mt-4 position-relative w-95'>
              <input
                type='text'
                className='form-control font-size-13 fw-300 ps-4 pe-14 py-4'
                placeholder='Start typing your message here...'
                value={userInput}
                onChange={handleInputChange}
                onKeyPress={(e) => {
                  if (e.key === 'Enter' && userInput.length <= 2000) {
                    chatSend()
                  }
                }}
              />
              <button
                type='button'
                className='position-absolute btn btn-transparent p-0 py-1'
                style={{right: '14px', top: '8px'}}
                onClick={chatSend}
              >
                <img src={Sendicon} alt='Send Message' />
              </button>
              {error && <div className='text-danger font-size-12 mt-1'>{error}</div>}
            </div>
          </div>
        </div>
      </div>
      <ViewDocModal
        isActive={isActive}
        setIsActive={setIsActive}
        fileName={fileName}
        isRecordKeeper={true}
        isLoading={isLoading}
        viewableData={viewableData}
      />
      <DeleteClassificationModal
        setDeleteShowModal={setModalOpen}
        showDeleteModal={modalOpen}
        handleDelete={deleteChat}
        deleteLoading={isDeleting}
        headingMessage={`Delete chat`}
        description={`Are you sure you want to delete this chat ?`}
      />
    </div>
  )
}

export default QueryAndPrompt
